import React from "react";
import packageJson from "../../package.json";
import { GLOBAL_CONSTANTS } from "../utils/Constants";
import { Col } from "reactstrap";

function Footer() {
  return (
    <footer className="footer">
      <div className="container d-flex">
        <Col className="text-right">
          <p>Powered by:</p>
        </Col>
        <Col className="text-left">
          <a
            href="https://www.morepaymentevolution.com/es/index.html#home"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="logo"
              src={GLOBAL_CONSTANTS.MORE_UNITELLER_LOGO}
              alt="More Payment Evolution"
              style={{ maxWidth: "70px" }}
            ></img>
          </a>
        </Col>
      </div>
    </footer>
  );
}

export default Footer;
